import {NgModule} from '@angular/core';
import {ChargedActConverter} from './api/entity/converter/chargedAct.converter';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {ChargedActDataService} from './impl/service/ngrx/chargedActData.service';
import {ChargedActRepository} from './impl/service/ngrx/chargedAct.repository';
import {errorMessages} from '../../core/error/errorMessages';
import {SaleModule} from "../../sale/sale.module";
import {
    AI_REALTIME_TOOL_DEFINITIONS,
    AiRealtimeToolDefinition
} from '../../ai/realtime/api/service/aiRealtime.service';
@NgModule({
    imports: [
        SaleModule
    ],
    providers: [
        {
            provide: AI_REALTIME_TOOL_DEFINITIONS,
            useValue: [
                {
                    toolName: 'add_billing_to_consultation',
                    runningLabel: 'Ajout d\'une facturation en cours',
                    errorLabel: 'Erreur lors de l’ajout de la facturation',
                    successLabel: 'Facturation ajoutée',
                    appEventNames: ['chargedAct']
                } as AiRealtimeToolDefinition],
            multi: true,
        }
    ]
})
export class MedicalChargedActModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: ChargedActDataService,
                repository: ChargedActRepository) {

        entityDataService.registerServices({
            ChargedAct: dataService,
        });

        entityServices.registerEntityCollectionServices({
            ChargedAct: repository,
        });
        errorMessages.set('SALE_SAVE_PAYMENT_REQUESTS_TOTAL_AMOUNT_DONT_MATCH_TOTAL_AMOUNT_VAT_INCLUDED', 'Le montant total des modalités de paiement ne correspond pas au montant total des actes facturés');
    }
}
